import { generateAnswerId } from '@dmp/qqms/survey-generators';
import type { AnswerState, CardState } from '../../state-types';

/**
 * Generate an answer shape based on card type
 */
export const generateAnswerShape = (
    cardType: CardState['type'],
    partialAnswer: Partial<AnswerState> = {}
): AnswerState | null => {
    switch (cardType) {
        case 'linearQuestion': {
            const id = partialAnswer.id || generateAnswerId('linearAnswer');
            const traxexLabel = partialAnswer.traxexLabel || id;
            return {
                type: 'linearAnswer',
                body: '',
                ...partialAnswer,
                id,
                traxexLabel,
            };
        }

        case 'forkedQuestion': {
            const id = partialAnswer.id || generateAnswerId('forkedAnswer');
            const traxexLabel = partialAnswer.traxexLabel || id;
            return {
                type: 'forkedAnswer',
                body: '',
                resultCard: undefined,
                ...partialAnswer,
                id,
                traxexLabel,
            };
        }

        default:
            return null;
    }
};
